export default [
    {
        text: 'id',
        value: 'id',
    },
    {
        text: 'producto',
        value: 'wh_product_name',
    },
    // {
    //     text: 'Producto',
    //     fieldType: 'computed',
    //     computed: ({ wh_product }) => {
    //         return wh_product.name
    //     },
    // },
    {
        text: 'cantidad',
        value: 'quantity',
    },
    {
        text: 'Precio Neto',
        value: 'net_price',
        format: 'currency',
    },
    {
        text: 'Descuento',
        value: 'discount_or_charge_percentage',
        format: 'percentage',
    },
    {
        text: 'Monto Descuento',
        value: 'discount_or_charge_value',
        format: 'currency',
    },
    {
        text: 'Total',
        value: 'subtotal',
        format: 'currency',
    },
]
